<template>
  <div class="d-flex">
    <v-icon
      v-if="typeof decrease === 'function'"
      color="error"
      @click="decrease && decrease(item)"
      small
    >
      fas fa-minus
    </v-icon>
    <strong class="mx-1">{{ item && item.qty }}</strong>
    <v-icon
      v-if="typeof increase === 'function'"
      @click="increase && increase(item)"
      color="primary"
      small
    >
      fas fa-plus
    </v-icon>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    increase: {
      type: Function,
    },
    decrease: {
      type: Function,
    },
  },
};
</script>
